/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	useLocation,
	useNavigate,
	useParams
} from "react-router-dom";

import {
	ComponentWrapper,
	StoreCard
} from "./StoreRules.styled";

import Button from "../../components/Button";
import Card, {
	CardBody,
	CardFooter,
	CardHeader
} from "../../components/Card";
import Img from "../../components/Img"; 

import i18nHelper from "../../helpers/i18n";
import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

import useApi from "../../hooks/api";

import i18n from "../../i18n";

// COMPONENT

const StoreRules = (props) => {
	const [
		error, 
		setError
	] = useState(null);
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	const [
		storeRules, 
		setStoreRules
	] = useState({});

	const {
		fetchApi
	} = useApi();
	const location = useLocation();
	const navigate = useNavigate();
	const params = useParams();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			const waitAsync = async () => {
				const response = await fetchApi({
					method: "get",
					params: {
						event_id: params.eventId,
						service: "getEventRules"
					}
				});

				if(response.error) {
					parseApiError(
						response.error.code,
						response.error.message
					);

					return;
				}

				const newStoreRules = {
					rules: response.payload.rules,
					store: {
						address: response.payload.store.address,
						city: response.payload.store.city,
						logo: response.payload.store.logo,
						name: response.payload.store.name,
						postalCode: response.payload.store.postal_code
					}
				};

				setStoreRules(newStoreRules);
			};

			waitAsync();
	    }, 
		[]
	);

	// Note - Run when storeRules change
	useEffect(
		() => {
			if(utilsHelper.isObjectEmpty(storeRules)) {
				return;
			}

			setIsRenderReady(true);
		}, 
		[storeRules]
	);

	// Events

	/**
	 * goBack - ...
	 * 
	 * @param {object} e ... 
	 */
	const goBack = (e) => {
		navigate(-1);
	};

	// Misc

	/**
	 * parseApiError - ...
	 * 
	 * @param {string} code ... 
	 */
	const parseApiError = (code, message) => {
		switch(code) {
			case 102: // Invalid access token
				reconnect();
			return;
			default:
				//setError(code);
				setError(
					message ||
					code
				);
			return;
		}
	};

	/**
	 * reconnect - ...
	 */
	const reconnect = () => {
		const {
			pathname,
			search
		} = location;
	
		navigate({
			pathname: routerHelper.getUrl("signIn"),
			search: `?redirect=${encodeURIComponent(pathname + search)}`
		});
	};

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		if(!isRenderReady) {
			return null;
		}

		let errorContent;

		if(error) {
			errorContent = (
				<div
					style={{
						borderRadius: "8px",
						backgroundColor: "#F04124",
						color: "#fff",
						padding: "16px"
					}}
					>
					{error}
				</div>
			);
		}

		return (
			<ComponentWrapper>
				{errorContent}
				<Card
					className="card"
					>
					<CardHeader>
						<strong>
							Store rules
						</strong>
					</CardHeader>
					<CardBody
						className="cardBody"
						>
						<StoreCard>
							<Img
								alt={storeRules.store.name}
								className="img"
								src={storeRules.store.logo}
							/>
							<div
								className="storeContent"
								>
								<strong>
									{storeRules.store.name}
								</strong>
								<p>
									<small>
										{storeRules.store.address}
									</small>
									<small>
										{`${storeRules.store.city}, ${storeRules.store.postalCode}`}
									</small>
								</p>
							</div>
						</StoreCard>
						<div
							style={{
								textAlign: "left",
								whiteSpace: "pre-wrap"
							}}
							>
							{storeRules.rules}
						</div>
					</CardBody>
				</Card>
				<a
					onClick={goBack}
					>
					Go back
				</a>
			</ComponentWrapper>
		);
	};

	return render();
};

// EXPORT

export default StoreRules;
